export function findRouteByName(routeName, router) {
  const searchRoutes = routes => {
    for (const route of routes) {
      if (route.name === routeName) {
        return route
      }
      if (route.children) {
        const found = searchRoutes(route.children)
        if (found) return found
      }
    }
    return null
  }

  return searchRoutes(router?.options.routes ?? [])
}

export function findFirstAvailableRoute(accessRules, parent_name, auth, router) {
  const parentRoute = findRouteByName(parent_name, router)

  if (!parentRoute) {
    return null
  }

  if (Array.isArray(parentRoute.children) && parentRoute.children.length > 0) {
    const availableChild = parentRoute.children.find(child => {
      const accessRulesList = child.meta?.access

      if (!accessRulesList || accessRulesList.length === 0) {
        return true
      }

      return accessRulesList.every(rule => accessRules[rule]?.(auth))
    })

    if (availableChild) {
      return availableChild
    }
  }

  return parentRoute
}
